import { GA_Push } from "./GoogleAnalytics";
import { mobile } from "./Agent";

var urlToShare = window.location.href;
var faceUrlToShare = `https://z.ynet.co.il/short/content/2020/templemount/?utm_source=${mobile() ? "m.ynet.co.il":"ynet.co.il"}&utm_medium=social&utm_campaign=facebook&utm_term=lebanon20`
var textToShare = `20 שנה לפרוץ האינתיפאדה השנייה >> https://z.ynet.co.il/short/content/2020/templemount/?utm_source=${mobile() ? "m.ynet.co.il":"ynet.co.il"}&utm_medium=social&utm_campaign=`;

const shareFacebook = () => {
  GA_Push("Share_Events", "Share From Site Head" ,"Facebook" , "Social");
  window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(faceUrlToShare), "_blank");
};

const shareTwitter = () => {
  GA_Push("Share_Events", "Share From Site Head"  , "Twitter", "Social");
  window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(textToShare + "twitter&utm_term=templemount"), "_blank");
  
};

const shareWhatsapp = () => {
  GA_Push("Share_Events", "Share From Site Head"  , "Whatsapp", "Social");
  if (mobile()) {
    window.open("whatsapp://send?text=" + encodeURIComponent(textToShare + "whatsapp&utm_term=templemount"), "_parent");
  } else {
    window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare + "whatsapp&utm_term=templemount"), "_blank");
  }
};

const openNegishut = () => {
  window.document.getElementById("INDmenu-btn").click();
  GA_Push("Accessibility", "Open_Accessibility_Clicked");
};

export { shareFacebook, shareTwitter, shareWhatsapp, openNegishut };
